import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Visibility } from '@material-ui/icons';

import { Fab } from '@material-ui/core';

import ContentCommenting from '../../common/components/ContentCommenting';
import * as PreviewStore from '../../app/store/PreviewStore';
import { InfoMessage, PageLayout } from '../../common/components';
import PreviewTaskContent from './components/PreviewTaskContent';
import { PREVIEW_TASK_RECEIVED } from '../../app/store/actions';
import { CommentIcon, PrintIcon } from '../../common/icons';

const styles = theme => ({
    root: {
    },
    actions: {
        display: 'flex',
        padding: theme.spacing(2),
    },
    fab: {
        marginRight: theme.spacing(2),
    },
    comments: {
        marginTop: theme.spacing(2),
    },
});

class PreviewTask extends React.Component {
    state = {
        noHiddenStateValue: false,
    }

    showPrint = () => {
        window.print();
    }

    toggleHiddenStates = () => {
        this.setState(prevState => ({
            noHiddenStateValue: !prevState.noHiddenStateValue,
        }));
    };

    render() {
        const {
            classes, translate, taskDetails, hasLoaded, showComments, toggleComments,
        } = this.props;

        const task = taskDetails;

        if (!task) {
            return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
        }

        return (
            <PageLayout
                title={task.name}
                task={task}
                breadcrumb={[{ text: task.moduleName }, { text: task.name }]}
                sideContent={(
                    <>
                        <div className={classes.actions}>
                            {task.contentElements?.some(e => e.elementStates) && (
                                <Fab
                                    onClick={this.toggleHiddenStates}
                                    className={classes.fab}
                                    color={this.state.noHiddenStateValue ? 'primary' : 'default'}
                                    title={this.state.noHiddenStateValue ? translate('preview.hideHiddenElements') : translate('preview.showHiddenElements')}
                                >
                                    <Visibility />
                                </Fab>
                            )}
                            <Fab
                                onClick={toggleComments}
                                className={classes.fab}
                                color={showComments ? 'primary' : 'default'}
                                title={showComments ? translate('taskCommenting.hideComments') : translate('taskCommenting.addOrShowComments')}
                            >
                                <CommentIcon />
                            </Fab>
                            <Fab
                                onClick={this.showPrint}
                                className={classes.fab}
                                color="default"
                                title={translate('taskCommenting.print')}
                            >
                                <PrintIcon />
                            </Fab>
                        </div>

                        {showComments && (
                            <ContentCommenting
                                task={task}
                                className={classes.comments}
                            />

                        )}
                    </>
                )}
            >
                <PreviewTaskContent
                    noHiddenStateValue={this.state.noHiddenStateValue}
                    task={task}
                />
            </PageLayout>
        );
    }
}

PreviewTask.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    toggleComments: PropTypes.func.isRequired,
    showComments: PropTypes.bool.isRequired,
    taskDetails: PropTypes.object,
};

PreviewTask.defaultProps = {
    taskDetails: null,
};

const mapStateToProps = (state, ownProps) => {
    const taskId = ownProps?.match?.params?.taskId;

    return {
        translate: getTranslate(state.localize),
        taskDetails: state.previewStore.details && state.previewStore.details[taskId],
        clientConfig: state.auth.clientConfig,
        hasLoaded: Boolean(state.previewStore.requests[`${PREVIEW_TASK_RECEIVED}/${taskId}`]
        && state.previewStore.requests[`${PREVIEW_TASK_RECEIVED}/${taskId}`].completed),
        showComments: state.previewStore.showComments,
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PreviewStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PreviewTask));
